import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[autofocusDirective]'
})
export class AutoFocusDirective implements AfterViewInit {
  @Input() autofocusDirective = true;

  constructor(
    private elementRef: ElementRef
  ) { }

  ngAfterViewInit() {
    if(!this.autofocusDirective) {
      return;
    }
    // setTimeout is to avoid change detection errors with modals screens
    setTimeout(() => {
      if(this.elementRef.nativeElement.nodeName === 'ODS-BUTTON') {
        this.elementRef.nativeElement.shadowRoot.querySelector('button').focus({
          preventScroll: true
        });
      } else {
        this.elementRef.nativeElement.focus({
          preventScroll: true
        });
      }
    }, 1);
  }
}
